import { type User, type UserRole } from "@/services/users/user.types"

interface UserWithTenantRoles {
  tenant_roles: { name: UserRole }[]
}

const isUserActive = (user: Pick<User, "status">) => user.status === "active"

export const isUserInactive = (user: Pick<User, "status">) =>
  !isUserActive(user)

export const USER_STATUS_LABELS = {
  active: "Active",
  closed: "Deactivated",
} as const

export const getUserStatusLabel = (user: Pick<User, "status">) =>
  isUserActive(user) ? USER_STATUS_LABELS.active : USER_STATUS_LABELS.closed

const isUserNonGuest = (user: Pick<User, "license_type">) =>
  user.license_type !== "guest"

export const isUserGuest = (user: Pick<User, "license_type">) =>
  user.license_type === "guest"

export const filterActiveNonGuestUsers = (users: User[]) =>
  users.filter((user) => isUserActive(user) && isUserNonGuest(user))

export const getTenantRoles = (user: UserWithTenantRoles) => user.tenant_roles

export const getPrimaryTenantRole = (user: UserWithTenantRoles): UserRole =>
  getTenantRoles(user)[0]?.name ?? "member"

export const hasTenantRole = (user: UserWithTenantRoles, role: UserRole) =>
  getTenantRoles(user).some((tenantRole) => tenantRole.name === role)
